import { formatNepaliDate, adToBS, addBSMonths, NEPALI_MONTHS } from './nepaliDate';

// ── Primary date formatter — always shows Nepali BS date ──────────────────
export { formatNepaliDate as formatDate };

// Raw BS object (if you need year/month/day separately)
export { adToBS };

// For date <input type="date"> values — stays as AD (HTML standard)
export const toInputDate = (date) => {
  if (!date) return '';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';
  return d.toISOString().split('T')[0];
};

export const todayInputDate = () => new Date().toISOString().split('T')[0];

// Expiry = same BS day, N BS months later
// e.g. Jestha 17, 2083 + 1 month = Ashadh 17, 2083 (exact BS date)
export const calcExpiryDate = (joiningDate, plan) => addBSMonths(new Date(joiningDate), plan);

// kept for anything that still imports it
export const getPlanDays = (plan) => {
  if (plan === 'Monthly')   return 30;
  if (plan === 'Quarterly') return 90;
  if (plan === 'Yearly')    return 365;
  return 30;
};

export const formatCurrency = (amount) => {
  if (amount === undefined || amount === null) return '₹0';
  return `₹${Number(amount).toLocaleString('en-IN')}`;
};

export const statusColor = (status) => {
  switch (status) {
    case 'Active':        return 'status-active';
    case 'Expired':       return 'status-expired';
    case 'Frozen':        return 'status-frozen';
    case 'Expiring Soon': return 'status-expiring';
    case 'Paid':          return 'status-paid';
    case 'Partial':       return 'status-partial';
    case 'Due':           return 'status-due';
    default:              return 'status-default';
  }
};

export const getInitials = (name) => {
  if (!name) return 'M';
  return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
};

export const daysUntilExpiry = (expiryDate) => {
  const now = new Date();
  const exp = new Date(expiryDate);
  return Math.ceil((exp - now) / (1000 * 60 * 60 * 24));
};
